import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import theme from '../../theme'

// application components
import Typography from '@mui/material/Typography';
import Card from '../../components/Card/Card'
import CardTextElement from '../../components/Card/CardText'
import Sidebar from '../../components/Sidebar/Sidebar'
import SidebarItem from '../../components/Sidebar/SidebarItem/SidebarItem'
import PersonalInformation from '../../components/User/PersonalInformation'
import AccountAdministration from '../../components/User/AccountAdministration'
import ControlCameraIcon from '@mui/icons-material/ControlCamera';
import Box from '@mui/material/Box';

// applicaton icons
import PersonalDataIconSrc from '../../assets/personalDataSVG'
import AccountAdministrationIconSrc from '../../assets/accountAdministrationSVG'
import AccountPasswordChange from "../../components/User/AccountPasswordChange";
import toast from "../../../utils/ToasterService";

import 'react-toastify/dist/ReactToastify.css'
import AccountDeletion from "../../components/User/AccountDeletion";
import ApiAccessManagement from "../../components/User/apiAccessManaging";
import log from 'loglevel'
import { t } from 'i18next'
import { Trans } from 'react-i18next'

const styles = {
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        display: 'flex',
        height: '100%',
    },
    cardWrapper: {
        display: 'flex',
        flexDirection: 'column',
        overflowX:'hidden',
        overflowY:"auto",
        height:'100%',
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
        },
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            flexDirection: 'column',
            height:'100%',
            overflowX:'hidden',
            overflowY:"auto",
        }
    },
    cardsTitle: {
        //position: 'absolute',
        marginTop: 20,
        marginBottom: 10,
        padding: '0 10px 10px 0',
        [theme.breakpoints.down('xs')]: {
            marginLeft: '7px',
        },
    },
    cards: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        paddingTop: theme.spacing.unit * 8,
        marginBottom:theme.dimensions.cardGap,
        paddingBottom:20,
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom:theme.dimensions.cardGap,
            paddingBottom:20,
        },
    },
    textStyle: {
        fontWeight: 600,
        lineHeight: 2,
        color: theme.palette.error.dark,
    },
    resetText: {
        lineHeight: 2,
        fontWeight: 600,
    },
}

class User extends PureComponent {
    static propTypes = {
        user: PropTypes.shape({
            email: PropTypes.string.isRequired
        }),
        onAccountDeletion: PropTypes.func.isRequired,
        onAccountChangePassword: PropTypes.func.isRequired,
        revokeToken: PropTypes.func.isRequired
    }

    static defaultProps = {
        user: {},
    }

    state = {
        activeCard: false,      // which card element is active
        sidebarOpen: false,     // sidebar flag
        sidebarChanged: false,  // data changing set

        userPasswordChange: false,   // flag for pwd change (for sidebar state)
        userDeleteAccount: false,   // flag for account deleting (for sidebar state)

        tokenIssuedState: this.props.tokenIssued
    }

    resetState = () => {
        this.setState({
            activeCard: false,
            sidebarOpen: false,
            sidebarChanged: false,

            userPasswordChange: false,
            userDeleteAccount: false,
            tokenIssuedState: false
        })
    };


    /**
     * set active card
     * @param activeCard
     */
    changeCard = activeCard => {
        this.setState({
            sidebarOpen: true,
            sidebarChanged: false,
            userPasswordChange: false,
            userDeleteAccount: false,
            activeCard,
        })
        this.props.resetToken();
    }

    /**
     * closing sidebar
     */
    handleSidebarClose = () => {
        this.resetState();
        this.props.resetToken();
    };

    /**
     * set flag for pwd change
     */
    handleUserPwdChange = () => {
        this.setState((prevState => ({
            sidebarChanged: false,
            userPasswordChange: !prevState.userPasswordChange,
            userDeleteAccount: false,
            tokenIssuedState: false
        })))
    }

    /**
     * set flag for deleting user profile
     */
    handleAccountDeletion = () => {
        this.setState((prevState => ({
            sidebarChanged: false,
            userDeleteAccount: !prevState.userDeleteAccount,
            userPasswordChange: false,
            tokenIssuedState: false
        })))
    }

     /**
     * set flag for deleting user profile
     */
      handleTokenState = () => {
        this.setState((prevState => ({
            sidebarChanged: false,
            userDeleteAccount: false,
            userPasswordChange: false,
            tokenIssuedState: !prevState.tokenIssuedState
        })))
    }



    /**
     * depends on sidebar action flags
     * @returns {boolean}
     */
    getCurrentSidebarAction = () => {
        let action = false
        if (this.state.userPasswordChange) {
            action = 'userPwdChange'
        } else if (this.state.userDeleteAccount) {
            action = 'userDelete'
        } else if (this.props.tokenIssued) {
            action = 'tokenAction'
        }
        return action
    }

    /**
     * dispatching actions
     */
    handleSidebarChange = () => {
        this.resetState();
    };

    /**
     * depending on pwd and reset flag
     * @returns {string}
     */
    getSidebarTitle = () => {
        let title = ''
        switch (this.state.activeCard) {
            case 1:
                title = (this.state.userPasswordChange) ? t('User.sidebartitle_passwordchange_action') : t('User.sidebartitle_passwordchange_no_action')
                break
            case 2:
                title = (this.state.userDeleteAccount) ? t('User.sidebartitle_account_action') : t('User.sidebartitle_account_no_action')
                break
            case 3:
                title = (this.props.tokenIssued) ? t('User.sidebartitle_api_action') : t('User.sidebartitle_api_no_action')
                break
            default:
                break
        }
        return title
    }

    onPasswordChangeSuccess = () => {
        toast.success(t('User.toast_password_change_success') );
        this.resetState();
    };

    onAccountDeletionSuccess = () => {
        toast.success(t('User.toast_account_deletion_success'));
        this.props.router.push('/login')
    };

    render () {
        const { classes } = this.props
        log.debug(this.props.tokenData)
        return (
            <div style={styles.root}>
                <div style={styles.cardWrapper}>
                <span style={styles.cardsTitle}>
                    <Typography variant="h5"><Trans i18nKey="PageTitles.user"></Trans></Typography>
                </span>
                    <Box style={styles.cards} rowGap={theme.dimensions.cardGap/7} columnGap={theme.dimensions.cardGap/7}>
                        <Card
                            label={t('User.card_label_personal_data')}
                            icon={<PersonalDataIconSrc width={100} height={100}/>}
                            handleCardState={() => this.changeCard(1)}
                            active={!(this.state.activeCard === 1 || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement
                                label={[t('User.card_text_personal_data_01'),
                                t('User.card_text_personal_data_02'),
                                t('User.card_text_personal_data_03'),
                                t('User.card_text_personal_data_04'),
                                t('User.card_text_personal_data_05')]}/>
                        </Card>
                        <Card
                            label={t('User.card_label_account_administration')}
                            icon={<AccountAdministrationIconSrc width={100} height={100}/>}
                            handleCardState={() => this.changeCard(2)}
                            active={!(this.state.activeCard === 2 || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement
                                label={[
                                t('User.card_text_account_administration_01'),
                                t('User.card_text_account_administration_02'),
                                t('User.card_text_account_administration_03'),
                                t('User.card_text_account_administration_04')
                                ]}/>
                        </Card>
                        <Card
                            label={t('User.card_label_api')}
                            icon={<ControlCameraIcon   style={{ color: '#fff',    fontSize: 90 } }/>}
                            handleCardState={() => this.changeCard(3)}
                            active={!(this.state.activeCard === 3 || !this.state.sidebarOpen)}
                            color={theme.palette.primary.dark}
                        >
                            <CardTextElement
                                label={[
                                t('User.card_text_api_01'),
                                t('User.card_text_api_02'),
                                t('User.card_text_api_03'),
                                t('User.card_text_api_04')
                                ]}/>
                        </Card>
                    </Box>
                </div>

                <Sidebar title={this.getSidebarTitle()}
                         open={this.state.sidebarOpen}
                         changed={this.state.sidebarChanged || this.props.tokenIssued}
                         closed={() => this.handleSidebarClose()}
                         action={this.getCurrentSidebarAction()}
                         tokenIssued={this.props.tokenIssued}
                         handleSidebarChange={() => this.handleSidebarChange()}
                >
                    {(1 === this.state.activeCard && !this.state.userPasswordChange)
                    && (
                        <PersonalInformation
                            changePassword={() => this.handleUserPwdChange()}
                            userEmail={this.props.user.email}
                        />
                    )
                    }

                    {(1 === this.state.activeCard && this.state.userPasswordChange) && (
                        <AccountPasswordChange onChangeRequest={this.props.onAccountChangePassword}
                                               onSuccess={this.onPasswordChangeSuccess}
                        />
                    )}

                    {(2 === this.state.activeCard && !this.state.userDeleteAccount)
                    && (
                        <AccountAdministration
                            handleAccountDeletion={() => this.handleAccountDeletion()}
                        />
                    )
                    }

                    {(2 === this.state.activeCard && this.state.userDeleteAccount)
                    && (
                        <SidebarItem>
                           <AccountDeletion onRequestDeletion={this.props.onAccountDeletion}
                                            onSuccess={this.onAccountDeletionSuccess}
                           />
                        </SidebarItem>
                    )
                    }

                    {(3 === this.state.activeCard)
                    && (
                        //<SidebarItem>
                           <ApiAccessManagement
                            //    onRequestToken={this.props.onTokenRequest}
                               tokenData={this.props.tokenData}
                               tokenIssued={this.props.tokenIssued}
                               onSuccess={this.onAccountDeletionSuccess}
                               revokeToken={this.props.revokeToken}
                               requestToken={this.props.requestToken}

                           />
                        //</SidebarItem>
                    )
                    }

                </Sidebar>

            </div>
        )
    }
}

//User = withStyles(styles)(User)

export default User
